var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftWithBorder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5356",
    "data-name": "Group 5356",
    transform: "translate(-0.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    transform: "translate(0.479)",
    fill: "#fff8e4",
    stroke: "#ffc629",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 73,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4058",
    "data-name": "Group 4058",
    transform: "translate(40.942 38.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4028",
    "data-name": "Group 4028",
    transform: "translate(3.142 28.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4018",
    "data-name": "Group 4018",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M101.853,229.978v36.137a4.714,4.714,0,0,0,4.714,4.714h50.277a4.714,4.714,0,0,0,4.714-4.714V229.978Z",
    transform: "translate(-101.853 -229.978)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4019",
    "data-name": "Group 4019",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1470",
    "data-name": "Rectangle 1470",
    width: 59.704,
    height: 3.142,
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4020",
    "data-name": "Group 4020",
    transform: "translate(51.848 1.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M382.74,229.978v36.137a4.713,4.713,0,0,1-4.713,4.714h4.713a4.714,4.714,0,0,0,4.714-4.714V229.978Z",
    transform: "translate(-378.027 -229.978)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4021",
    "data-name": "Group 4021",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M158.415,267.686H109.709a3.142,3.142,0,0,1-3.142-3.142V229.978h-4.714v36.137a4.714,4.714,0,0,0,4.714,4.714h50.277a4.714,4.714,0,0,0,4.714-4.714v-1.571A3.142,3.142,0,0,1,158.415,267.686Z",
    transform: "translate(-101.853 -229.978)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4022",
    "data-name": "Group 4022",
    transform: "translate(51.848 36.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M378.027,426.133h4.713a4.714,4.714,0,0,0,4.714-4.714v-1.571a3.142,3.142,0,0,1-3.142,3.142h-1.86A4.7,4.7,0,0,1,378.027,426.133Z",
    transform: "translate(-378.027 -419.848)",
    fill: "#ccdcff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4023",
    "data-name": "Group 4023",
    transform: "translate(56.562 1.571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1471",
    "data-name": "Rectangle 1471",
    width: 4.713,
    height: 3.142,
    fill: "#553ff2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4024",
    "data-name": "Group 4024",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1472",
    "data-name": "Rectangle 1472",
    width: 4.713,
    height: 3.142,
    fill: "#ccdcff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4025",
    "data-name": "Group 4025",
    transform: "translate(0 20.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M149.785,357.111H99.508a6.292,6.292,0,0,1-6.285-6.285V335.115a1.571,1.571,0,0,1,3.142,0v15.712a3.146,3.146,0,0,0,3.142,3.142h50.277a3.146,3.146,0,0,0,3.142-3.142V341.4a1.571,1.571,0,0,1,3.142,0v9.426A6.292,6.292,0,0,1,149.785,357.111Z",
    transform: "translate(-93.223 -333.544)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4026",
    "data-name": "Group 4026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M154.5,244.915a1.571,1.571,0,0,1-1.571-1.571V224.49H96.365v7.856a1.571,1.571,0,0,1-3.142,0v-9.427a1.571,1.571,0,0,1,1.571-1.571h59.7a1.571,1.571,0,0,1,1.571,1.571v20.425A1.571,1.571,0,0,1,154.5,244.915Z",
    transform: "translate(-93.223 -221.348)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4027",
    "data-name": "Group 4027",
    transform: "translate(0 14.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M94.794,303.737a1.571,1.571,0,0,1-1.571-1.571V300.6a1.571,1.571,0,1,1,3.142,0v1.57A1.571,1.571,0,0,1,94.794,303.737Z",
    transform: "translate(-93.223 -299.025)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4035",
    "data-name": "Group 4035",
    transform: "translate(0 15.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4029",
    "data-name": "Group 4029",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1473",
    "data-name": "Rectangle 1473",
    width: 65.989,
    height: 12.569,
    rx: 6.285,
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4030",
    "data-name": "Group 4030",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M147.438,160.935H144.3a1.571,1.571,0,0,1,1.571,1.571v6.285a1.571,1.571,0,0,1-1.571,1.571H86.163a1.571,1.571,0,0,1-1.571-1.571v1.571a3.142,3.142,0,0,0,3.142,3.142h59.7a3.142,3.142,0,0,0,3.142-3.142v-6.285A3.142,3.142,0,0,0,147.438,160.935Z",
    transform: "translate(-84.592 -160.935)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4031",
    "data-name": "Group 4031",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M147.438,160.935h-59.7a3.142,3.142,0,0,0-3.142,3.142v6.285a3.142,3.142,0,0,0,3.142,3.142h3.142a1.571,1.571,0,0,1-1.571-1.571v-6.285a1.571,1.571,0,0,1,1.571-1.571h58.133a1.571,1.571,0,0,1,1.571,1.571v-1.571A3.142,3.142,0,0,0,147.438,160.935Z",
    transform: "translate(-84.592 -160.935)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4032",
    "data-name": "Group 4032",
    transform: "translate(1.571 9.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M89.306,207.229v-1.571H86.163a1.571,1.571,0,0,1-1.571-1.571v1.571a3.142,3.142,0,0,0,3.142,3.142h3.142A1.571,1.571,0,0,1,89.306,207.229Z",
    transform: "translate(-84.592 -204.087)",
    fill: "#ccdcff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4033",
    "data-name": "Group 4033",
    transform: "translate(61.275 1.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M415.691,160.935h-3.142a1.571,1.571,0,0,1,1.571,1.571v1.571h3.142a1.571,1.571,0,0,1,1.571,1.571v-1.571A3.142,3.142,0,0,0,415.691,160.935Z",
    transform: "translate(-412.549 -160.935)",
    fill: "#ccdcff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4034",
    "data-name": "Group 4034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M140.379,168.016h-59.7a4.719,4.719,0,0,1-4.713-4.714v-6.285a4.719,4.719,0,0,1,4.713-4.714h59.7a4.719,4.719,0,0,1,4.713,4.714V163.3A4.719,4.719,0,0,1,140.379,168.016Zm-59.7-12.569a1.573,1.573,0,0,0-1.571,1.571V163.3a1.573,1.573,0,0,0,1.571,1.571h59.7a1.573,1.573,0,0,0,1.571-1.571v-6.285a1.573,1.573,0,0,0-1.571-1.571Z",
    transform: "translate(-75.962 -152.304)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4040",
    "data-name": "Group 4040",
    transform: "translate(26.71 28.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4036",
    "data-name": "Group 4036",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1474",
    "data-name": "Rectangle 1474",
    width: 12.569,
    height: 40.85,
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4037",
    "data-name": "Group 4037",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1475",
    "data-name": "Rectangle 1475",
    width: 12.569,
    height: 3.142,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4038",
    "data-name": "Group 4038",
    transform: "translate(1.571 39.279)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1476",
    "data-name": "Rectangle 1476",
    width: 12.569,
    height: 3.142,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4039",
    "data-name": "Group 4039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M236.819,265.34H224.25a1.571,1.571,0,0,1-1.571-1.571v-40.85a1.571,1.571,0,0,1,1.571-1.571h12.569a1.571,1.571,0,0,1,1.571,1.571v40.85A1.571,1.571,0,0,1,236.819,265.34Zm-11-3.142h9.427V224.49h-9.427Z",
    transform: "translate(-222.679 -221.348)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4045",
    "data-name": "Group 4045",
    transform: "translate(26.71 15.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4041",
    "data-name": "Group 4041",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1477",
    "data-name": "Rectangle 1477",
    width: 12.569,
    height: 12.569,
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4042",
    "data-name": "Group 4042",
    transform: "translate(1.571 10.998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1478",
    "data-name": "Rectangle 1478",
    width: 12.569,
    height: 3.142,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4043",
    "data-name": "Group 4043",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1479",
    "data-name": "Rectangle 1479",
    width: 12.569,
    height: 3.142,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4044",
    "data-name": "Group 4044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M236.819,168.016H224.25a1.571,1.571,0,0,1-1.571-1.571V153.875a1.571,1.571,0,0,1,1.571-1.571h12.569a1.571,1.571,0,0,1,1.571,1.571v12.569A1.571,1.571,0,0,1,236.819,168.016Zm-11-3.142h9.427v-9.427h-9.427Z",
    transform: "translate(-222.679 -152.304)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4049",
    "data-name": "Group 4049",
    transform: "translate(39.279 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4046",
    "data-name": "Group 4046",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M300.353,90.343l20.184-4.777a2.357,2.357,0,0,0,1.245-3.827l-3.273-3.815a9.406,9.406,0,0,0-7.158-3.292,11,11,0,0,0-11,11Z",
    transform: "translate(-300.353 -74.631)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4047",
    "data-name": "Group 4047",
    transform: "translate(2.151 1.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M324.388,81.739l-3.273-3.815a9.4,9.4,0,0,0-7.158-3.292A11,11,0,0,0,303.539,82.1a10.955,10.955,0,0,1,7.276-2.752,9.406,9.406,0,0,1,7.158,3.292l2.961,3.452,2.209-.523a2.358,2.358,0,0,0,1.245-3.827Z",
    transform: "translate(-303.539 -74.631)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4048",
    "data-name": "Group 4048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M293.294,84.854a1.571,1.571,0,0,1-1.571-1.571V78.569A12.583,12.583,0,0,1,304.292,66a10.991,10.991,0,0,1,8.351,3.841l3.273,3.815a3.928,3.928,0,0,1-2.076,6.379l-20.184,4.777A1.568,1.568,0,0,1,293.294,84.854Zm11-15.712a9.437,9.437,0,0,0-9.427,9.427V81.3l18.251-4.319a.786.786,0,0,0,.414-1.275l-3.273-3.815A7.852,7.852,0,0,0,304.292,69.142Z",
    transform: "translate(-291.723 -66)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4053",
    "data-name": "Group 4053",
    transform: "translate(4.713 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4050",
    "data-name": "Group 4050",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M132.48,90.343,112.3,85.566a2.357,2.357,0,0,1-1.245-3.827l3.273-3.815a9.406,9.406,0,0,1,7.158-3.292,11,11,0,0,1,11,11Z",
    transform: "translate(-110.484 -74.631)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4051",
    "data-name": "Group 4051",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M124.624,79.344A10.955,10.955,0,0,1,131.9,82.1a11,11,0,0,0-10.418-7.465,9.4,9.4,0,0,0-7.158,3.292l-3.273,3.815a2.357,2.357,0,0,0,1.245,3.827l2.209.523,2.961-3.452A9.406,9.406,0,0,1,124.624,79.344Z",
    transform: "translate(-110.484 -74.631)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4052",
    "data-name": "Group 4052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M125.42,84.854a1.567,1.567,0,0,1-.362-.042l-20.184-4.777a3.928,3.928,0,0,1-2.076-6.379l3.273-3.815A10.99,10.99,0,0,1,114.422,66a12.583,12.583,0,0,1,12.569,12.569v4.714a1.571,1.571,0,0,1-1.571,1.571Zm-11-15.712a7.851,7.851,0,0,0-5.966,2.744L105.184,75.7a.786.786,0,0,0,.414,1.275L123.849,81.3V78.569A9.437,9.437,0,0,0,114.422,69.142Z",
    transform: "translate(-101.853 -66)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4057",
    "data-name": "Group 4057",
    transform: "translate(26.71 7.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4054",
    "data-name": "Group 4054",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M239.166,117.783h-3.142a4.713,4.713,0,0,0-4.713,4.713v3.142h12.569V122.5A4.713,4.713,0,0,0,239.166,117.783Z",
    transform: "translate(-231.31 -117.783)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4055",
    "data-name": "Group 4055",
    transform: "translate(1.571 1.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M239.166,119.354h3.142c.13,0,.252.028.379.038a4.682,4.682,0,0,0-3.522-1.609h-3.142a4.713,4.713,0,0,0-4.713,4.713v3.142h3.142v-1.571A4.713,4.713,0,0,1,239.166,119.354Z",
    transform: "translate(-231.31 -117.783)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4056",
    "data-name": "Group 4056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M236.819,120.15H224.25a1.571,1.571,0,0,1-1.571-1.571v-3.142a6.292,6.292,0,0,1,6.285-6.285h3.142a6.292,6.292,0,0,1,6.285,6.285v3.142A1.571,1.571,0,0,1,236.819,120.15Zm-11-3.142h9.427v-1.571a3.146,3.146,0,0,0-3.142-3.142h-3.142a3.146,3.146,0,0,0-3.142,3.142Z",
    transform: "translate(-222.679 -109.152)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftWithBorder);
export default __webpack_public_path__ + "static/media/giftWithBorder.b03b0012781fabf544de27aa326f6acc.svg";
export { ForwardRef as ReactComponent };